import { LPMatrixDisplayV2VirtualDisplayForceType } from '../../Components/Map/Components/LPMatrixDisplay/ForceLPMatrixDisplay/FlowChart/LPMatrixDisplayFactory';

export class LPDisplayEventForceType {
    private _isBlack: boolean;
    private _counters: LPDisplayForceTypeCountersInterface[];
    private _virtualDisplays: LPDisplayForceTypeVirtualDisplaysInterface[];
    private _topology: number;
    private _isForce: boolean;

    constructor(data: LPDisplayEventForceTypeData) {
        this._isBlack = data.isBlack;
        this._counters = data.counters;
        this._virtualDisplays = data.virtualDisplays;
        this._topology = data.topologyNum;
        this._isForce = data.isForce;
    }

    public getIsBlack(): boolean {
        return this._isBlack;
    }

    public getCounters(): LPDisplayForceTypeCountersInterface[] {
        return this._counters;
    }

    public getVirtualDisplays(): LPDisplayForceTypeVirtualDisplaysInterface[] {
        return this._virtualDisplays;
    }

    public getTopology(): number {
        return this._topology;
    }

    public getIsForce(): boolean {
        return this._isForce;
    }
}

export type LPDisplayEventForceTypeData = {
    isBlack: boolean;
    counters: LPDisplayForceTypeCountersInterface[];
    virtualDisplays: LPDisplayForceTypeVirtualDisplaysInterface[];
    topologyNum: number;
    isForce: boolean;
};

export interface LPDisplayForceTypeCountersInterface {
    numCounter: number;
    mode: number;
    value: number;
}

export interface LPDisplayForceTypeVirtualDisplaysInterface {
    numVirtualDisplay: number;
    mode: LPMatrixDisplayV2VirtualDisplayForceType;
    step: LPDisplayForceTypeVirtualDisplaysStepInterface;
}

export interface LPDisplayForceTypeVirtualDisplaysStepInterface {
    color: {
        red: number;
        blue: number;
        green: number;
    };
    mode: number;
    time: number;
    pictoSize: number;
    picto: number;
    arrowSize: number;
    arrow: number;
    stepOrder: number;
    state: number;
    transition: number;
    textTransformation: number;
    triggerMax: {
        value: number;
        action: number;
    };
    triggerMin: {
        value: number;
        action: number;
    };
}
